<template>
	<div class="con">
		<div class="head">
			<div class="head-left">
				<img src="../assets/doctor.png" />
				<div class="userDetalis">
					<div class="username">{{user.YSXM}}</div>
					<div class="usertype">{{user.JBMC}}</div>
					<div class="usertype">{{user.subjects}}</div>
				</div>
			</div>
			<div class="head-right">
				<div class="xingxing" @click="onCollection">
					<img :src="xing == false ? xingshow : xinghide " />
					<div class="code-text" v-if="xing == false">收藏医生</div>
					<div class="code-text-active" v-else>已收藏</div>
				</div>
				<div @click="Consulting">
					<van-icon name="chat-o" size="30"/>
					<div class="code-text">咨询</div>
				</div>
			</div>
		</div>
		<div class="nav">
			<div v-for="item in navList" @click="navBtn(item.id)"><span :class="item.id == nav ? 'nav-text':''">{{item.text}}</span></div>
		</div>
		<!--挂号-->
		<div class="nav-left" v-if="nav == 0">
			<div class="nav-left-time">{{user.chooseTime}}</div>
			<div class="list">
				<div class="list-text" v-for="(item,index) in list" @click="confirBtn(index)" v-if="item.SL > 0">
					<div class="time">{{item.TIMESLOT}}</div>
					<div class="price">余号{{item.SL}}
						<van-icon name="arrow" color="#999" />
					</div>
					<!--<van-icon name="arrow" color="#999" />-->
				</div>
			</div>
		</div>
		<!--介绍-->
		<div class="nav-right" v-if="nav == 1">
			<div class="nav-right-title">
				擅长
			</div>
			<div class="nav-right-text" v-if="user.goodAt">
				{{user.goodAt}}
			</div>
			<div class="nav-right-text" v-else>
				暂无相关信息
			</div>
			<div class="nav-right-title">
				介绍
			</div>

			<div class="nav-right-text" v-if="user.introduce">
				{{user.introduce}}
			</div>
			<div class="nav-right-text" v-else>
				暂无相关信息
			</div>
		</div>

		<div class="noImg" v-if="noImgShow == true && nav == 0">
			<img src="../assets/404.gif" />
			<div class="no-text">无数据~</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'doctorDetails',
		data() {
			return {
				msg: '医生详情',
				user: {},
				cardUserInfo: JSON.parse(localStorage.getItem('cardUserInfo')),
				xing: false,
				xingshow: require('../assets/stars-1.png'),
				xinghide: require('../assets/stars.png'),
				nav: 0, // 0、挂号 1、介绍
				navList: [{
						id: 0,
						text: '挂号'
					},
					{
						id: 1,
						text: '介绍'
					},
				],
				list: [],
				noImgShow: false,
			}
		},
		methods: {
			//导航
			navBtn(e) {
				this.nav = e;
			},
			//点击时间段
			confirBtn(e) {
				let lis = this.list[e];
				let user = this.user;
				for(let i in lis) {
					user[i] = lis[i]
				}
				console.log(user)
				this.$router.push({
					path: '/regConfirmation',
					query: {
						user: JSON.stringify(this.user)
					}
				})
			},
			//获取就诊时间段
			//zblx值班类型，通过这个值获取 医生值班时间
			GetGyYgzblx() {
//				let timeList = this.user.timeSlot.split('[');
//				timeList = timeList[1].split(']');
//				timeList = timeList[0].split(',');
//
//				let chooseT = this.user.chooseTime + ' ' + timeList[0];
				
				let chooseT = this.user.chooseTime;
				
				this.$store.commit('Load', true)
//				this.$Axios.Get('/gyYgzblx?ghsj=' + chooseT + '&ksdm=' + this.user.ksdm + '&ysdm=' + this.user.YGDM + '&wxghSl=' + this.user.WXGHSL + '&timeSlot=' + timeList, null).then(data => {
				this.$Axios.Get('/gyYgzblxX?ghsj=' + chooseT + '&ksdm=' + this.user.ksdm + '&ysdm=' + this.user.YSDM, null).then(data => {
					this.$store.commit('Load', false)
					console.log(data)
					if(data.code == 0) {
						if(data.msg.length != 0) {
							this.noImgShow = false;
							this.list = data.msg;
						} else {
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}

				}).catch(err => {
					this.noImgShow = true;
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//咨询聊天
			Consulting(){
				this.$router.push({path:'/chatRoom',query:{doctor: JSON.stringify(this.user)}})
			},
			//查询是否收藏
			GetCollectState() {
				this.$store.commit('Load', true)
				this.$Axios.Get('/collect/getCollectState?ygdm=' + this.user.YSDM + '&brid=' + this.cardUserInfo.brid, null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.code == 0) {
						if(res.collectState == 1) {
							this.xing = true;
						} else {
							this.xing = false;
						}
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},
			//收藏医生
			onCollection() {
				if(this.cardUserInfo == '') {
					this.$dialog.confirm({
						title: '登录',
						message: '是否去绑定个人信息？'
					}).then(() => {
						this.$router.push('/patient')
					}).catch(() => {});
					return false;
				}
				this.$store.commit('Load', true)
				this.$Axios.Post('/collect/collectDoctor?ygdm=' + this.user.YSDM + '&brid=' + this.cardUserInfo.brid, null).then(res => {
					console.log(res)
					this.$store.commit('Load', false)
					if(res.data.code == 0) {
						if(res.data.collectState == 1) {
							this.$toast.success('收藏成功')
							this.xing = !this.xing;
						} else {
							this.$toast.success('取消成功')
							this.xing = !this.xing;
						}
					} else {
						this.$toast.success('请检查网络')
					}
				}).catch(err => {
					this.$store.commit('Load', false)
					console.log(err)
				})
			},

		},
		mounted() {
			this.user = JSON.parse(this.$route.query.doctor);
			this.GetGyYgzblx();
			console.log(this.user)
			this.GetCollectState()
			
		},
		created() {

		},
	}
</script>

<style scoped>
	.noImg {
		margin-top: 10vh;
		text-align: center;
	}
	
	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;
	}
	
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}
	
	.head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 15px;
		background-color: #fff;
	}
	
	.head-left {
		display: flex;
		align-items: center;
	}
	
	.head-left img {
		margin-right: 10px;
		width: 60px;
		height: 60px;
	}
	
	.username {
		color: #000000;
		font-size: 15px;
	}
	
	.usertype {
		margin-top: 10px;
		color: #666;
	}
	
	.head-right {
		display: flex;
		text-align: center;
	}
	
	.xingxing {
		margin-right: 20px;
	}
	
	.head-right img,
	.xingxing img {
		width: 30px;
		height: 30px;
	}
	
	.code-text {
		margin-top: 5px;
		font-size: 12px;
	}
	.code-text-active{
		margin-top: 5px;
		color: #F4EA2A;
	}
	.nav {
		display: flex;
		justify-content: space-around;
		padding: 15px;
		font-size: 15px;
		background-color: #fff;
	}
	
	.nav-left {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
	}
	
	.nav-left-time {
		padding: 10px;
		font-size: 15px;
		margin: 0 auto;
	}
	
	.nav-right {
		flex: 1;
		padding: 10px;
		margin-top: 10px;
		background-color: #fff;
	}
	
	.nav-right-title {
		font-size: 16px;
		font-weight: 700;
		color: #000;
	}
	
	.nav-right-text {
		margin: 10px 0;
		font-size: 14px;
		color: #999;
	}
	
	.nav-text {
		padding: 10px;
		color: #27bec4;
		border-bottom: 2px solid #27BEC4;
	}
	
	.list {
		flex: 1;
		overflow-y: scroll;
		background-color: #fff;
	}
	
	.list-text {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 10px;
		font-size: 15px;
		border-bottom: 1px solid #ccc;
		color: #000;
		font-weight: 700;
	}
	
	.price {
		display: flex;
		align-items: center;
		color: red;
		font-weight: 500;
	}
	
	.colccc {
		color: #ccc;
	}
	
	.footer {
		padding: 5px 0;
		text-align: center;
		font-size: 12px;
	}
	
	.footer-title {
		color: #000;
		font-size: 14px;
	}
	
	.footer-text span {
		margin-left: 10px;
		color: #1296db;
	}
</style>